import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { OrderProvider } from './context/OrderContext';
import { NotificationProvider } from './context/NotificationContext';

import Layout from './components/layout/Layout';
import ProtectedRoute from './components/common/ProtectedRoute';

import Login from './pages/Login';
import POS from './pages/POS';
import NotFound from './pages/NotFound';

import DashboardManagement from './components/layout/DashboardManagement';
import CustomerManagement from './components/customers/CustomerManagement';
import SubscriptionManagement from './components/subscriptions/SubscriptionManagement';
import PlanManagement from './components/subscriptions/PlanManagement';
import ServiceManagement from './components/services/ServiceManagement';
import ServiceTypeManagement from './components/services/ServiceTypeManagement';
import OrderManagement from './components/orders/OrderManagement';
import PaymentSystem from './components/payments/PaymentSystem';
import RoleManagement from './components/roles/RoleManagement';

const App = () => (
  <Router>
    <AuthProvider>
      <NotificationProvider>
        <OrderProvider>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<DashboardManagement />} />
              <Route path="/pos" element={<POS />} />
              <Route path="/customers" element={<CustomerManagement />} />
              <Route path="/subscriptions" element={<SubscriptionManagement />} />
              <Route path="/subscriptions/plans" element={<PlanManagement />} />
              <Route path="/services" element={<ServiceManagement />} />
              <Route path="/services/types" element={<ServiceTypeManagement />} />
              <Route path="/orders" element={<OrderManagement />} />
              <Route path="/payments" element={<PaymentSystem />} />
              <Route path="/roles" element={<RoleManagement />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </OrderProvider>
      </NotificationProvider>
    </AuthProvider>
  </Router>
);

export default App;
